import PropTypes from "prop-types";
import React, { useMemo } from "react";
import CreatableSelect from "react-select/creatable";

export const FormDropDownCreatable = ({
  options,
  labelName,
  id,
  required = false,
  requiredAny = false,
  onChange,
  value,
  isMulti = false,
  error,
}) => {
  const sortedOptions = useMemo(() => {
    const validOptions = Array.isArray(options) ? options : [];
    return [...validOptions].sort((a, b) => a.localeCompare(b));
  }, [options]);

  const makeOptions = (x) => {
    return { value: x, label: x };
  };

  return (
    <div className="my-2 mt-0">
      <label className="block font-normal text-lg" htmlFor={id}>
        {labelName}
        {required && (
          <sup className="text-red-500 font-bold text-lg ml-1">*</sup>
        )}
        {requiredAny && (
          <sup className="text-red-500 font-bold text-lg ml-1">**</sup>
        )}
      </label>

      <CreatableSelect
        options={sortedOptions?.map((x) => makeOptions(x))}
        isMulti={isMulti}
        id={id}
        className={`form-control mt-1 block w-full mt-1 border ${
          error ? "border-red-500" : "border-gray-300"
        } rounded-sm shadow-sm`}
        onChange={onChange}
        value={value}
        aria-label={labelName}
        formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
      />
      {error && <span className="text-red-500 text-sm">{error.message}</span>}
    </div>
  );
};

FormDropDownCreatable.propTypes = {
  labelName: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  required: PropTypes.bool,
  requiredAny: PropTypes.bool,
  isMulti: PropTypes.bool,
  error: PropTypes.object,
  id: PropTypes.string,
};
